module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_1.2d946885.webp";